export const PRAGMATIKA_TOKEN = 'pragmatika';
